
import { Component, ElementRef, OnInit } from '@angular/core';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerAlert, DealerService } from '@app-services/dealer.service';
import { ToastrService } from 'ngx-toastr';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: 'app-saved-searches',
  templateUrl: './saved-searches.component.html',
  styleUrls: ['./saved-searches.component.scss'],
  animations: [SharedAnimations]
})
export class SavedSearchesComponent implements OnInit {
  loading: boolean;
  alerts: DealerAlert[];

  constructor(
    private dealerService: DealerService,
    private toaster: ToastrService,
    private openService: OpenService,
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.loading = true;

    this.openService.getLayoutVars().subscribe(layoutVars => {
      MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
    });

    this.dealerService.getAlerts()
      .subscribe(r => {
        this.alerts = r;
        this.loading = false;
      });
  }

  deleteAlert(alert: DealerAlert): void {
    this.loading = true;
    this.dealerService.deleteAlert(alert.id)
      .subscribe(r => {
        if (r.success) {
          this.alerts = this.alerts.filter(a => a.id !== alert.id);
          this.toaster.success(`Alerta ${alert.name} removido com sucesso`);
        } else {
          this.toaster.error(`Não foi possível remover o alerta ${alert.name}: ${r.message}`);
        }
        this.loading = false;
      });
  }

  toggleAlertStatus(alert: DealerAlert): void {
    this.dealerService.updateAlertStatus(alert.id, !alert.inactive)
      .subscribe(r => {
        if (r.success) {
          alert.inactive = !alert.inactive;
          this.toaster.success(`A partir de agora você ${alert.inactive ? 'não vai mais' : 'vai'} receber novas ofertas por email para a busca ${alert.name}`);
        } else {
          this.toaster.error(`Não foi possível alterar o status do alerta ${alert.name}: ${r.message}`);
        }
      });
  }

}
